<template>
  <div class="mv-bg-main">
    <el-card class="mr">
        <ve-histogram :width="width"  :dataZoom="dataZoom1" :grid="grid" :not-set-unchange="['dataZoom']" :extend="extend" :data-empty="supEmpty" :data="reachesData" :title="reachesTitle"></ve-histogram>
    </el-card>
    <el-card class="mr" style="height: 600px;">
      <el-form :inline="true" ref="searchForm" :model="form" class="demo-form-inline " label-width="125px">
        <el-form-item label="业务系统" prop="sysId">
          <el-select v-model="form.sysId" multiple collapse-tags  clearable filterable placeholder="请选择业务系统">
            <el-option :label="item.systemName" :value="item.systemId" v-for="(item, $index) in sysData" :key="$index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="统计日期" prop="date">
          <el-date-picker
            v-model="form.date"
            :editable = "editable"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="float-r">
          <el-button type="primary" size="small" @click="onSubmit">查询</el-button>
          <el-button type="primary" size="small" @click="downBill">账单下载</el-button>
        </el-form-item>
      </el-form>
      <ve-histogram :width="width" :dataZoom="dataZoom" :grid="grid" :not-set-unchange="['dataZoom']" :extend="extend" :data-empty="callEmpty" :data="callData" :title="businessTitle"></ve-histogram>
    </el-card>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
.mr {
  margin: 10px;
  width: 100%;
}
</style>
<script>
import 'v-charts/lib/style.css'
export default {
  name: 'fullAnalysis',
  data () {
    this.extend = {
      series: {
        label: { show: true, position: 'top' },
        barWidth: 60
      }
    }
    this.grid = {
      left: 0
    }
    return {
      supEmpty: false,
      callEmpty: false,
      sysData: [],
      dataZoom: [
        {
          type: 'slider',
          xAxisIndex: [0],
          start: 0,
          end: 60
        },
        {
          type: 'slider',
          yAxisIndex: [0]
        }
      ],
      editable: false,
      form: {
        sysId: [],
        date: ''
      },
      width: '94%',
      dataZoom1: [
        {
          type: 'slider',
          xAxisIndex: [0]
        },
        {
          type: 'slider',
          yAxisIndex: [0]
        }
      ],
      reachesTitle: {
        text: '上下游统计',
        itemGap: 20,
        top: '',
        left: 'left',
        textStyle: {
          color: '#FF6694',
          fontSize: 20
        }
      },
      businessTitle: {
        text: '业务域调用统计',
        itemGap: 20,
        top: '',
        left: 'left',
        textStyle: {
          color: '#FF6694',
          fontSize: 20
        }
      },
      reachesData: {
        columns: ['平台', '当月新增', '历史总数', '在服总数', '停用总数', '删除总数'],
        rows: [
        ]
      },
      callData: {
        columns: ['平台', '账单', '客户', '供应商', '计价', '产品'],
        rows: [
        ]
      }
    }
  },
  computed: {
    // sysData () {
    //   return this.$store.state.sysData
    // }
  },
  created () {
    let _this = this
    let op = {}
    op.pageNum = 1
    op.pageSize = 100
    this.$axios({
      url: _this.$API.apiList.oldquerySysList,
      method: 'post',
      data: op
    }).then((response) => {
      console.log(response)
      _this.sysData = response.data.resData.data
    }).catch((err) => {
      console.log(err)
    })
    let getSupper = () => { // 请求供应商
      return this.$axios({
        url: _this.$API.analysis.querySupDataStatistic,
        // url: 'http://172.16.9.132:5010/agw/operatAnalysisCtr/querySupDataStatistic',
        method: 'get'
      })
    }
    let getCus = () => { // 请求客户
      return this.$axios({
        url: _this.$API.analysis.queryCustDataStatistic,
        // url: 'http://172.16.9.132:5010/agw/operatAnalysisCtr/queryCustDataStatistic',
        method: 'get'
      })
    }
    // if (!this.sysData.length) {
    //   this.$store.dispatch('getSystem') // 请求业务系统
    // }
    // let getCall = () => { // 请求调用量
    //   return this.$axios({
    //     url: _this.$API.analysis.querySysCallStatistic,
    //     method: 'post',
    //     data: {}
    //   })
    // }
    this.querySysProfit()
    this.$axios.all([getSupper(), getCus()]).then(_this.$axios.spread(function (sup, cus) {
      if (sup.data.resData && cus.data.resData) {
        let supOp = {}
        let cusOp = {}
        _this.supEmpty = false
        supOp['平台'] = '供应商'
        supOp['当月新增'] = sup.data.resData.newAdd
        supOp['历史总数'] = sup.data.resData.histTotal
        supOp['在服总数'] = sup.data.resData.inServiceTotal
        supOp['停用总数'] = sup.data.resData.disableTotal
        supOp['删除总数'] = sup.data.resData.delTotal
        cusOp['平台'] = '客户'
        cusOp['当月新增'] = cus.data.resData.newAdd
        cusOp['历史总数'] = cus.data.resData.histTotal
        cusOp['在服总数'] = cus.data.resData.inServiceTotal
        cusOp['停用总数'] = cus.data.resData.disableTotal
        cusOp['删除总数'] = cus.data.resData.delTotal
        _this.reachesData.rows.push(supOp)
        _this.reachesData.rows.push(cusOp)
      } else {
        _this.supEmpty = true
      }
    }))
  },
  methods: {
    downBill () { // 下载账单
      let url = this.$API.accounting.downloadSysCallStatistic
      // let url = 'http://172.16.9.132:5010/agw/operatAnalysisCtr/downloadSysCallStatistic'
      let op = {}
      let id = this.form.sysId
      op.sysIds = id
      if (!this.form.date) { // 默认展示当前30天数据
        let date = new Date()
        let day = date.getDate()
        let month = date.getMonth() + 1 // 获取当前月份
        let year = date.getFullYear()
        let lastDate = new Date(date - 1000 * 60 * 60 * 24 * 30) // 获取默认前30天时间
        let getLastDay = lastDate.getDate() // 获取默认前30天 天份
        let getLastMonth = lastDate.getMonth() + 1 // 获取默认前30天 月份
        let getLastYear = lastDate.getFullYear() // 获取默认前30天 年份
        op.beginTime = getLastYear + '-' + (getLastMonth < 10 ? '0' + getLastMonth : getLastMonth) + '-' + (getLastDay < 10 ? '0' + getLastDay : getLastDay) + ' 00:00:00'
        op.endTime = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day) + ' 23:59:59'
      } else {
        op.beginTime = this.form.date ? this.form.date[0] + ' 00:00:00' : ''
        op.endTime = this.form.date ? this.form.date[1] + ' 23:59:59' : ''
      }
      op.mtk = localStorage.getItem('usermtk')
      let form = document.createElement('form')
      form.id = 'form'
      form.name = 'form'
      document.body.appendChild(form)
      for (let obj in op) {
        if (op.hasOwnProperty(obj)) {
          var input = document.createElement('input')
          input.tpye = 'hidden'
          input.name = obj
          input.value = op[obj]
          form.appendChild(input)
        }
      }
      form.method = 'POST' // 请求方式
      form.action = url
      form.submit()
      document.body.removeChild(form)
    },
    querySysProfit () {
      let op = {}
      let id = this.form.sysId
      op.sysIds = id
      if (!this.form.date) { // 默认展示当前30天数据
        let date = new Date()
        let day = date.getDate()
        let month = date.getMonth() + 1 // 获取当前月份
        let year = date.getFullYear()
        let lastDate = new Date(date - 1000 * 60 * 60 * 24 * 30) // 获取默认前30天时间
        let getLastDay = lastDate.getDate() // 获取默认前30天 天份
        let getLastMonth = lastDate.getMonth() + 1 // 获取默认前30天 月份
        let getLastYear = lastDate.getFullYear() // 获取默认前30天 年份
        op.beginTime = getLastYear + '-' + (getLastMonth < 10 ? '0' + getLastMonth : getLastMonth) + '-' + (getLastDay < 10 ? '0' + getLastDay : getLastDay) + ' 00:00:00'
        op.endTime = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day) + ' 23:59:59'
      } else {
        op.beginTime = this.form.date ? this.form.date[0] + ' 00:00:00' : ''
        op.endTime = this.form.date ? this.form.date[1] + ' 23:59:59' : ''
      }
      let _this = this
      this.$axios({
        url: _this.$API.analysis.querySysCallStatistic,
        // url: 'http://172.16.9.132:5010/agw/operatAnalysisCtr/querySysCallStatistic',
        method: 'post',
        data: op
      }).then((response) => {
        _this.callData.rows = []
        if (response.data && response.data.resData.length) {
          _this.callEmpty = false
          for (let v of response.data.resData) {
            let callOp = {}
            callOp['平台'] = v.systemName
            for (let o of v.callInfos) {
              switch (o.module) {
                case 'bill':
                  callOp['账单'] = o.callCount
                  break
                case 'cust':
                  callOp['客户'] = o.callCount
                  break
                case 'msp':
                  callOp['供应商'] = o.callCount
                  break
                case 'mcpa':
                  callOp['计价'] = o.callCount
                  break
                case 'prod':
                  callOp['产品'] = o.callCount
                  break
                default:
                  break
              }
            }
            _this.callData.rows.push(callOp)
          }
          console.log(_this.callData)
        } else {
          _this.callEmpty = true
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    onSubmit () {
      this.querySysProfit()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/analysis/fullAnalysis.vue